import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class ProductivityDashboardService {

  constructor(private ws: PostmethodService) { }

  getLeadSource(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardLeadSourceFilter");
  }

  getGeography(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardgeogrphicalFilter");
  }

  getUser(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardOutletFilter");
  }

  getProduct(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardProductFilter");
  }

  getZoneCounts(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardCount");
  }

  getStageCounts(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardTestRideCount");
  }

  getGeographyChartCounts(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardGeographyCount");
  }

  getPerformanceCounts(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardProductivityCount");
  }

  getPerformanceCountsByPD(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/DashboardParentDealerProductivityCount");
  }

  getParentDealerChartCount(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/DashboardParentDealerCount");
  }
  
  getDealersAndOutlets(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardParentOutletFilter");
  }

  getRegionalMgrs(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/regionalManagerFilter");
  }

  getAreaMgrs(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/areaManagerFilter");
  }
}
